import React from 'react';
import { StyleSheet, View } from 'react-native';
import { H1 } from '@expo/html-elements';
import {
  theme,
  TitleText,
  useBreakpointHelpers,
  useResponsive,
} from '@sg/garnish';

import { useLocalizationContext } from '@order/Localization';

export const SweetpassCheckoutHeader = () => {
  const { t } = useLocalizationContext();
  const { isMobile } = useBreakpointHelpers();
  const { match, minWidth } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const headingStyles = [
    styles.heading,
    minWidth.tablet ? styles.headingSM : undefined,
    { color: isMobile ? undefined : theme.colors.LIME },
  ];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={match([styles.headerMobile, styles.headerTabletUp])}>
      <H1 style={headingStyles}>
        <TitleText size={match([3, 4])} style={headingStyles}>
          {t('sweetpass.checkout.header')}
        </TitleText>
      </H1>
    </View>
  );
};

//
// ─── STYLES ─────────────────────────────────────────────────────────────────────
//

const styles = StyleSheet.create({
  headerMobile: {
    paddingBottom: theme.spacing.xlarge,
  },
  headerTabletUp: {
    paddingVertical: theme.spacing.xlarge,
  },
  heading: {
    marginVertical: 0,
  },
  headingSM: {
    textAlign: 'center',
    marginVertical: 0,
  },
});
